export default "__VITE_ASSET__MuRsL7GJ__"